
const titles = {
  404: 'UPS ... siden er væk',
  default: 'Desværre, vi kan ikke hjælpe dig Online',
  expressBankRejected: 'Ansøgning om afdrag er afvist af Resurs Bank'
}

const descriptions = {
  404: ' Vi kan ikke finde den side, du leder efter. Den er måske fjernet, har skiftet navn eller er midlertidigt utilgængelig. Uanset hvad, vil vi gerne prøve at hjælpe dig videre.',
  400: ' Vi kan ikke finde den side, du leder efter. Den er måske fjernet, har skiftet navn eller er midlertidigt utilgængelig. Uanset hvad, vil vi gerne prøve at hjælpe dig videre.',
  default: ' Kontakt venligst kundeservice på tlf. 70 21 89 00 for yderligere oplysninger.',
  500: ' Der er gået kludder i vores system, prøv igen om lidt.',
  expressBankRejected: 'På baggrund af de oplysninger, du har angivet i ansøgningsskemaet, er dit ønske om at købe en mobil med afdragsordning desværre blevet afvist. Af samme årsag har vi annulleret din bestilling, og din binding er automatisk blevet fjernet.\n\nDu har stadig mulighed for at købe en mobil kontant.'
}


export default {
  name: 'EmptyLayout',
  layout: 'empty',
  props: {
    error: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      title: '',
      description: '',
      linkButtons: [
        {
          url: '/shop/mobiltelefoner',
          text: 'Se mobiltelefoner'
        },
        {
          url: '/shop/tilbehoer',
          text: 'Se tilbehør'
        },
        {
          url: '/mobilabonnement',
          text: 'Se abonnementer'
        },
        {
          url: '../hjaelp',
          text: 'Gå til hjælp'
        }
      ]
    }
  },
  head() {
    const title = titles[this.error.statusCode] ? titles[this.error.statusCode] : titles.default
    this.title = title
    this.description = descriptions[this.error.statusCode]
      ? descriptions[this.error.statusCode]
      : descriptions.default + ' Oplys fejlkode ' + this.error.statusCode
    return {
      title
    }
  },
  computed: {
    image() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return require('@/assets/images/404-desktop.jpeg')
      } else if (this.$vuetify.breakpoint.smAndUp) {
        return require('@/assets/images/404-tablet.jpeg')
      }
      return require('@/assets/images/404-mobil.jpeg')
    }
  }
}
